export default __webpack_public_path__ + "static/media/single-webiner.686564ca.jpg";